import { LocaleActions } from './types';
import { Locale, OutputChannels } from '../types';

export const setLocale = (locale: Locale) => {
  return {
    type: LocaleActions.SetLocale,
    payload: locale,
  };
};

export const setOnlineChannel = (channel: OutputChannels) => {
  return async (dispatch) => {
    dispatch({
      type: LocaleActions.SetOnlineChannel,
      payload: channel,
    });
  };
};
